import { configure } from 'mobx';
import React from 'react';
import './src/InitializeConfig';
import { createRoot } from 'react-dom/client';
import { App } from './src/App';
const initialStateHolder = { initialState: window.INITIAL_STATE };
configure({
    enforceActions: 'always',
    computedRequiresReaction: true,
    isolateGlobalState: false
});
const render = (AppComponent, props) => {
    const node = document.getElementById('container');
    const root = createRoot(node);
    root.render(React.createElement(AppComponent, { ...props }));
};
render(App, initialStateHolder);
if (module.hot) {
    module.hot.accept('./src/App', () => {
        render(App, initialStateHolder);
    });
}
